module.exports = __webpack_public_path__ + "static/swoosh-b8b06c2b2c84cb56a9429a97a0bd2ab7.png";